import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import DiagnosisInformation from "../../components/patient-timeline/diagnosis"

const DiagnosisContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <DiagnosisInformation />
      </div>
    </div>
  )
}

export default DiagnosisContainer